import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TimeOnTaskIcon = (props: SvgProps) => <Svg
  width={20}
  height={20}
  viewBox='0 0 20 20'
  fill='none'
  {...props}
>
  <Path
    d='M10.833 6.52706C10.833 6.06682 10.4599 5.69373 9.99965 5.69373C9.53942 5.69373 9.16632 6.06706 9.16632 6.5273C9.16632 7.7352 9.16632 8.65225 9.16632 9.86016C9.16632 10.3204 9.53942 10.6937 9.99965 10.6937H13.333C13.7932 10.6937 14.1663 10.3206 14.1663 9.86039C14.1663 9.40016 13.7932 9.02706 13.333 9.02706H10.833V6.52706Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M9.99935 3.33268C6.31745 3.33268 3.33268 6.31745 3.33268 9.99935C3.33268 13.3996 5.87828 16.2053 9.16767 16.6146C9.62439 16.6715 9.99935 17.0391 9.99935 17.4993C9.99935 17.9596 9.62517 18.3371 9.16718 18.2917C4.95552 17.8741 1.66602 14.3209 1.66602 9.99935C1.66602 5.39698 5.39698 1.66602 9.99935 1.66602C14.3209 1.66602 17.8741 4.95552 18.2917 9.16718C18.3371 9.62518 17.9596 9.99935 17.4993 9.99935C17.0391 9.99935 16.6715 9.62438 16.6146 9.16767C16.2053 5.87828 13.3996 3.33268 9.99935 3.33268Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M11.666 13.7792C11.666 13.5333 11.8547 13.334 12.0875 13.334H12.1308C12.3636 13.334 12.5523 13.5333 12.5523 13.7792C12.5523 14.0251 12.3636 14.2244 12.1308 14.2244H12.0875C11.8547 14.2244 11.666 14.0251 11.666 13.7792Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M11.666 17.8888C11.666 17.6429 11.8547 17.4436 12.0875 17.4436H12.1308C12.3636 17.4436 12.5523 17.6429 12.5523 17.8888C12.5523 18.1347 12.3636 18.334 12.1308 18.334H12.0875C11.8547 18.334 11.666 18.1347 11.666 17.8888Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M14.1628 13.7792C14.1628 13.5901 14.3079 13.4367 14.487 13.4367H19.6751C19.8542 13.4367 19.9993 13.5901 19.9993 13.7792C19.9993 13.9683 19.8542 14.1217 19.6751 14.1217H14.487C14.3079 14.1217 14.1628 13.9683 14.1628 13.7792ZM14.1628 15.834C14.1628 15.6448 14.3079 15.4915 14.487 15.4915H19.6751C19.8542 15.4915 19.9993 15.6448 19.9993 15.834C19.9993 16.0231 19.8542 16.1765 19.6751 16.1765H14.487C14.3079 16.1765 14.1628 16.0231 14.1628 15.834ZM14.1628 17.8888C14.1628 17.6996 14.3079 17.5463 14.487 17.5463H19.6751C19.8542 17.5463 19.9993 17.6996 19.9993 17.8888C19.9993 18.0779 19.8542 18.2312 19.6751 18.2312H14.487C14.3079 18.2312 14.1628 18.0779 14.1628 17.8888Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M11.666 15.834C11.666 15.5881 11.8547 15.3888 12.0876 15.3888H12.1308C12.3636 15.3888 12.5523 15.5881 12.5523 15.834C12.5523 16.0799 12.3636 16.2792 12.1308 16.2792H12.0876C11.8547 16.2792 11.666 16.0799 11.666 15.834Z'
    fill={props.color ?? '#4A535A'}
  />
</Svg>;

export default TimeOnTaskIcon;
